// extracted by mini-css-extract-plugin
module.exports = {"chartsWrapper":"EnergyGraphs_chartsWrapper__yFJYF","graphHeaderWrapper":"EnergyGraphs_graphHeaderWrapper__eOCmo","graphWrapper":"EnergyGraphs_graphWrapper__p2Vkx"};